/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { NonNegativeInteger } from "@pagopa/ts-commons/lib/numbers";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";

// required attributes
const CreditorInstitutionStationEditR = t.interface({
  station_code: t.string
});

// optional attributes
const CreditorInstitutionStationEditO = t.partial({
  aca: t.boolean,

  application_code: NonNegativeInteger,

  aux_digit: t.union([
    WithinRangeInteger<0, 3, IWithinRangeIntegerTag<0, 3>>(0, 3),
    t.literal(3)
  ]),

  broadcast: t.boolean,

  mod4: t.boolean,

  segregation_code: NonNegativeInteger,

  spontaneous_payment: t.boolean,

  stand_in: t.boolean
});

export const CreditorInstitutionStationEdit = t.intersection(
  [CreditorInstitutionStationEditR, CreditorInstitutionStationEditO],
  "CreditorInstitutionStationEdit"
);

export type CreditorInstitutionStationEdit = t.TypeOf<
  typeof CreditorInstitutionStationEdit
>;
